// src/Components/Auth/RegisterForm.js
import React from 'react';
import './registerForm.css';

const RegisterForm = ({ email, setEmail, password, setPassword, onRegister, error, confirmPassword, setConfirmPassword }) => {
  return (
    <div className="login-container">
      <form onSubmit={onRegister} className="login-form">
        <h2>Registreer</h2>
        {error && <p className="error-message">{error}</p>}
        <div className="input-group">
          <label htmlFor="email">Email address</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="input-group">
          <label htmlFor="password">Wachtwoord</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="input-group">
          <label htmlFor="confirm-password">Bevestig Wachtwoord</label>
          <input
            type="password"
            id="confirm-password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="login-button">Registreer</button>
        <p>
          Heb je al een account? <a href="/login">Log hier in</a>
        </p>
      </form>
    </div>
  );
};

export default RegisterForm;
